import { useLocation } from "react-router-dom";
import { LocalStorageService } from "../base/services/local-storage.service";
import { isBusinessAccount, isBusinessAllowedPath } from "../base/services/accountLevel.service";

/**
 * Keeps a business account inside the pages it is offered. The menu already
 * hides the rest, so this only catches what a menu can't — a bookmark, a link
 * shared by a teammate, a hand-typed URL.
 *
 * Returns the path to send the account to, or null when the current page is one
 * it may open: its surveys while it is inside a project, and otherwise the root
 * route, which redirects on to its workspaces.
 */
export const useBusinessAccountRedirect = () => {
   const { pathname } = useLocation();

   if (!isBusinessAccount() || isBusinessAllowedPath(pathname)) return null;

   return LocalStorageService.getItem("currentProjectID") ? "/surveys" : "/";
};
